// Demo mode configuration
export const DEMO_CONFIG = {
  clicksPerCycle: 1000,
  weiPerCycle: 100,
  minWithdrawal: 1000,
  maxWithdrawal: 100000,
  maxDailyWithdrawal: 50000,
  maxWeeklyWithdrawal: 250000,
  maxMonthlyWithdrawal: 1000000,
};

// Game configuration
export const GAME_CONFIG = {
  baseMultiplierCost: 100,
  multiplierCostIncrease: 50,
  baseAutoClickerCost: 1000,
  maxMultipliers: 10,
  maxAutoClickers: 5,
};